/**
 * Chapter025.js — Incident & Injury Investigation Policy (OHSE 025)
 * Migrated from SWMS Platform Chapter025.tsx → JavaScript
 *
 * Static policy text only — company name is the only variable.
 *
 * Props:
 *   companyName {string}  from companyInfo.name
 */

export default function Chapter025({ companyName }) {
  const cn = companyName || '[Company Name]';
  const Co = () => <span className="font-semibold text-[#c9a84c]">{cn}</span>;

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <p className="text-xs font-semibold text-[#c9a84c] uppercase tracking-widest mb-1">OHSE 025</p>
        <h2 className="text-xl font-bold text-[#1a1a2e] uppercase tracking-wide">
          Incident &amp; Injury Investigation
        </h2>
      </div>

      <div className="bg-white border border-[#e0dbd0] rounded-lg overflow-hidden">
        <div className="px-4 py-2.5 bg-[#f0ede6]">
          <h3 className="text-sm font-semibold text-[#1a1a2e] uppercase tracking-wide">
            Incident &amp; Injury Investigation Policy
          </h3>
          <p className="text-xs text-gray-500 mt-0.5">
            Procedures for reporting, recording and investigating workplace incidents and injuries
          </p>
        </div>
        <div className="p-6 space-y-4 text-sm text-[#1a1a2e] leading-relaxed">
          <p>All injuries are reported to the designated First Aid Officer in the workplace.</p>

          <p><Co /> records all injuries on the Register of Injuries.</p>

          <p>
            Where the injury requires medical attention or off site treatment,{' '}
            <Co /> completes an Incident Investigation Report.
          </p>

          <p>Copies of Incident Investigation Reports are provided to the principal contractor, as required.</p>

          <p>
            For all incidents involving near misses, property/plant damage or injury to the public or the environment,{' '}
            <Co /> investigates and records the details in an Incident Investigation Report.
          </p>

          <p>Copies of completed Incident Investigation Reports are provided to the principal contractor, as required.</p>

          <p><Co /> reports all notifiable incidents to the relevant Authority.</p>

          <p>
            Where such an incident has occurred,{' '}
            <Co /> considers whether the site needs to be preserved for investigation by the relevant Authority.
          </p>

          <p><Co /> keeps records of incidents and injuries in accordance with Statutory requirements.</p>
        </div>
      </div>
    </div>
  );
}
